import React, { useEffect, useState } from 'react';
import { instance } from "../Components/config";
import {
  List,
  ListItem,
  ListItemText,
  Typography as MuiTypography,
  Divider,
  Container,
  Box,
  Paper,
  Pagination
} from "@mui/material";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";
import { LoaderBox } from '../Components/LoaderBox';

function NotificationsPage() {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
  });
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;

  const paginatedNotifications = notifications.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  useEffect(() => {
    instance
      .get(`/notificacion/listByUser?id=${user.id}&limit=100`)
      .then((res) => {
        setNotifications(res.data)
        setLoading(false);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "Error",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
          setOpenDialog(true);
        }
        setLoading(false);
      })
      .finally();
  }, [user.id]);

  const handlePageChange = (event, value) => {
    setPage(value);
  }

  return (
    <LoaderBox isLoading={loading}>
      <Container maxWidth="l">
        <Box
          margin={2}
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="80vh"
        >
          <Paper elevation={3} style={{ padding: '20px', width: '100%', maxWidth: '600px' }}>
            <MuiTypography variant="h4" component="h2" textAlign={'center'} gutterBottom>
              Todas las Notificaciones
            </MuiTypography>
            {loading ? (
              <MuiTypography variant="body1" color="textSecondary">
                Cargando notificaciones...
              </MuiTypography>
            ) : (
              <>
                <List>
                  {paginatedNotifications.map((notification, index) => (
                    <>
                      <ListItem key={index} alignItems="flex-start">
                        <ListItemText
                          primary={
                            <MuiTypography variant="h6" component="span">
                              {notification.titulo}
                            </MuiTypography>
                          }
                          secondary={
                            <>
                              <MuiTypography component="span" variant="body2" color="textPrimary">
                                {notification.mensaje}
                              </MuiTypography>
                              {" - " + new Date(notification.fechaHora).toLocaleDateString("en-GB", { hour: "numeric", hour12: false, minute: "numeric" })}
                            </>
                          }
                        />
                      </ListItem>
                      <Divider variant="middle"/>
                    </>
                  ))
                  }
                </List>
                <Pagination
                  count={Math.ceil(notifications.length / itemsPerPage)}
                  page={page}
                  onChange={handlePageChange}
                  color='primary'
                  style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}
                />
              </>
            )}
          </Paper>
        </Box>
      </Container>
      {openDialog && (
        <DialogAlert
          title={dialog.title}
          text={dialog.text}
          open={openDialog}
          onClose={() => setOpenDialog(false)}
        />
      )}
    </LoaderBox>
  );
}

export { NotificationsPage };
